import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { COLORS, TYPE } from "../../../theme/styles/globals"
import { H3 } from "../../atomic/atoms/type/H3"
import TextField from "../../atomic/molecules/TextField"
import { ALIGN } from "../globals"

export default class ContentfulBlockText extends React.Component {
  render() {
    const { mode, align, accent, title, description, transition } = this.props

    return (
      <Container align={align} className={`block-text block-text-${align}`}>
        <Top>
          <Accent mode={mode}>{accent}</Accent>
          <Title mode={mode}>{title}</Title>
        </Top>
        {description && (
          <Description align={align} mode={mode}>
            <TextField mode={mode} json={description.json} transition={transition} />
          </Description>
        )}
      </Container>
    )
  }
}

const Container = styled.div`
  position: relative;
  padding-left: 14px;
  padding-right: 14px;
  width: 100%;
  padding-top: 0px;
  margin-bottom: 0px;

  ${up("md")} {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    margin-bottom: -30px;
    width: 550px;
    align-self: center;
    ${props => (props.align === ALIGN.RIGHT ? `margin-left:110px;` : ``)};
  }
`

const Top = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  z-index: 1;

  ${up("md")} {
    padding-left: 0px;
    padding-right: 0px;
  }
`

const Accent = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: block;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};

  ${up("md")} {
    &::before {
      content: " ";
      width: 80px;
      height: 1px;
      background-color: ${props =>
        props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
      display: inline-block;
      margin-right: 20px;
      transform: translate(0px, -3px);
    }
  }
`

const Title = styled(H3)`
  font-size: 42px;
  line-height: 42px;
  color: ${props => props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-top: 20px;

  ${up("sm")} {
    font-size: 48px;
    line-height: 48px;
  }

  ${up("md")} {
    font-size: 62px;
    line-height: 62px;
    margin-top: 30px;
  }
  
  ${up("lg")} {
    font-size: 72px;
    line-height: 72px;
    margin-top: 30px;
  }
`

const Description = styled.div`
  line-height:24px;
  color:${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.LIGHT_GREY_2}`};
  background-color:${props =>
    props.mode === "LIGHT"
      ? `${COLORS.LIGHT_GREY_1}`
      : `${COLORS.DARK_GREY_2}`};
  position:relative;
  z-index:0;

  -webkit-font-smoothing: antialiased;
  transform:translate3d( 0, 0, 0);

  ${props =>
    props.align === ALIGN.LEFT
      ? `
      padding-top:40px;
      padding-bottom:20px;
      padding-left:20px;
      padding-right:20px;
      transform:translate(0px, -20px);
    `
      : ``}
  
  ${props =>
    props.align === ALIGN.RIGHT
      ? `
      padding-top:40px;
      padding-bottom:20px;
      padding-left:20px;
      padding-right:20px;
      transform:translate(0px, -20px);
    `
      : ``}

  ${up("md")}{

    ${props =>
      props.align === ALIGN.LEFT
        ? `
      padding-top:60px;
      padding-bottom:30px;
      padding-left:60px;
      padding-right:60px;
      transform:translate(40px, -30px);
    `
        : ``}
    
    ${props =>
      props.align === ALIGN.RIGHT
        ? `
      padding-top:60px;
      padding-bottom:30px;
      padding-left:60px;
      padding-right:30px;
      transform:translate(40px, -30px);
    `
        : ``}


  }
`
